import { ThemeProvider, createTheme } from '@mui/material/styles';
import React, { useEffect, useState } from 'react';
import {
  useSearchParams,
} from "react-router-dom";
import { useCast } from './../../cast/CastProvider';
import { getUrlForRelative } from '../../services/url';
import { v4 as uuidv4 } from 'uuid';
import Messenger from '../items/Messenger';
import CurrentTime from '../player/CurrentTime';
import { throttle } from '../../services/throttle';
import dayjs from 'dayjs';
import TR from './../../Trans';
import ForceChangePassword from '../dialogs/ForceChangePassword';
import { Navigate } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import { Chromecast } from '@gameleap/capacitor-chromecast';
import { checkIfMobile } from '../../services/screen';
import { useMediaQuery } from 'react-responsive';
import { SafeArea } from 'capacitor-plugin-safe-area';
import ExternalViewCommands from './../../services/external';
import NewAccountDialog from '../dialogs/NewAccountDialog';
import ForceAcceptTerms from '../dialogs/ForceAcceptTerms';
import IosExternalLinkDialog from '../dialogs/IosExternalLinkDialog';
import MediaQuery from 'react-responsive';
import Landscape from './Landscape';
import { getOS, getPlatform, isDesktop, isPhone, isTablet, isSamsungBrowser } from './../../services/os';
import { setSafeAreas } from './../../services/safeareas';
import Error from './../items/Error';
import Message from './../items/Message';
import Portrait from './Portrait';
import AndroidSubDialog from '../dialogs/AndroidSubDialog';
import ExternalScreen from 'cordova-plugin-wkwebview-external-screen';
import { Capacitor } from '@capacitor/core';
import StrService from './../../services/str';
import { generateId } from './../../services/random';
import MuvikaService from './../../services/muvika';
import IntervalService from './../../services/intervals';
import navigationStore from '../../stores/navigation';
import sessionStore from './../../stores/session';
import performanceStore from '../../stores/performance';
import accountStore from '../../stores/account';
import messageStore from '../../stores/message';
import settingsStore from '../../stores/settings';
import singersStore from './../../stores/singers';
import EditPerformance from '../dialogs/EditPerformance';
import newTracksStore from './../../stores/newTracks';
import favoritesStore from '../../stores/favorites';
import catalogStore from '../../stores/catalog';
import environmentStore from '../../stores/environment';
import musicStore from '../../stores/music';
import musicPlayerStore from '../../stores/musicPlayer';
import newsStore from '../../stores/news';
import playerStore from '../../stores/player';
import searchStore from '../../stores/search';
import songListStore from '../../stores/songList';
import singerStore from './../../stores/singers';
import timeoutsStore from '../../stores/timeouts';
import statusStore from './../../stores/status';
import homeStore from '../../stores/home';
import SubscribeDialog from '../dialogs/SubscriptionDialog';
import UpdateDialog from './../dialogs/UpdateDialog';
import MessageDialog from './../dialogs/MessageDialog';
import { AndroidExternalScreen } from 'muvika-android-external-screen';
import muvikaAttrs from './../../attrs';
import bgFiltersStore from '../../stores/bgFilters';
import bgStylesStore from '../../stores/bgStyles';
import bgPerformanceStore from '../../stores/bgPerformance';
import bgSearchStore from '../../stores/bgSearch';
import bgPlaylistsStore from './../../stores/bgPlaylists';
import MuvikaMessenger from './MuvikaMessenger';
import MuvikaUI from './MuvikaUI';
import { useLocalStorage } from '../../services/useLocalStorage';
import { useSessionStorage } from '../../services/useSessionStorage';

function MuvikaApp() {

  const [isMobile, setIsMobile] = useSessionStorage(muvikaAttrs.service + "-mobile", false);
  const [platform, setPlatform] = useSessionStorage(muvikaAttrs.service + "-platform", null);

  const [fontSize, setFontSize] = useLocalStorage(muvikaAttrs.service + "-font", 16);
  
  useEffect(() => {
    document.documentElement.style.fontSize = `${fontSize}px`;
    window.dispatchEvent(new Event('refitbuttons'));
    window.dispatchEvent(new Event('resize'));
  }, [fontSize]);

  return (
    <div>
      <MuvikaMessenger isMobile={isMobile} platform={platform} />
      <MuvikaUI isMobile={isMobile} platform={platform} />
    </div>
  );
}

export default MuvikaApp;
